import getEnvFromHostname from '../../../../../helpers/getEnvFromHostname.ts';

const deriveRecaptchaKey = (): string | undefined => {
  const env = getEnvFromHostname();
  switch (env) {
    case 'local':
    case 'ue1dev1':
    case 'ue1dev2':
      return '6LfPaNwqAAAAAIYy54fWUSP-p-n0DOF70qpoAoAD';
    case 'ue1live':
      return '6LfDb70ZAAAAAJJrzQfDTcuPcoE9uLppBISisBO3';
    default:
      return undefined;
  }
};

export default deriveRecaptchaKey;
